import TVdxbApplicationInviteUserForm from './index.vue';

TVdxbApplicationInviteUserForm.install = app => {
  app.component(TVdxbApplicationInviteUserForm.name, TVdxbApplicationInviteUserForm);
};

export default TVdxbApplicationInviteUserForm;
